module.exports = __webpack_public_path__ + "Interest Waiver.pdf";